import upimg from './components/upimg.vue'

import login from './components/login.vue'
import it1024im from './components/it1024im.vue'
import mobile from './components/mobile.vue'
import mobilechat from './components/mobilechat.vue'
import setting from './components/setting.vue'

export var routerjs = [
    {
      path:'/',
      component:it1024im
    },
    {
      path:'/mobile',
      component:mobile  
    },
    {
      path:'/mobilechat',
      component:mobilechat  
    },
    {
      path:'/upimg',
      component:upimg  
    },
    {
      path:'/setting',
      component:setting  
    },
    {
      path:'/login',
      component:login
    },
    //路由重定向
    {
      path:'*',
      redirect: '/'
    }
]



// WEBPACK FOOTER //
// ./src/routerjs.js